//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetch } from "@/page/index";
import SrmCommonUtils from "@/utils/SrmCommonUtils"
import SelectionModal from "../../components/SelectionModal.vue";
import {Dialog, Notify} from 'vant'
export default {
    components: {
        SelectionModal
    },
    props: {
        imRoom: {
            type: Object,
            default: {}
        },
    },
	data() {
		return {
			operateType: String,
			title: "消息群组",
            showImGroupModal: false, //显示改密模态框
			receiptMsg: [],
      showUserFullName: false, // 显示供应商完整名称
			msgData: "",
			userFullName: "",
      currentImRoom: {},
			roomDesc: "",
			imRoomUserList: [],
			imRoomUserRemoveList: [],
			currentUserInfo: {},
            userSelectConf: {
                title: "用户选择",
                findApi: 'baseUsersService_findPagination',
                search: { key: 'userFullName', placeholder: '用户名称'},
                searchParams:{
                    userType: this.$store.state.user.userInfo.userType === "EXTERNAL" ? "INSIDE" : null
                },
                columns: [
                    { title: '用户名称', key: 'userFullName' },
                    { title: '应用平台', key: 'userType', lookup: {code: "SYS_DUTY_PLATFORM"} }
                ]
            },
		}
	},
    beforeCreate() {
        /*if (this.$store.state.user.userInfo.userType === "EXTERNAL") {
            this.userSelectConf.searchParams.userType = "INSIDE"
        }*/
    },
	mounted() {
		this.currentUserInfo = this.$store.state.user.userInfo;
        this.open()
	},
	methods: {
		open() {
			debugger
			this.roomDesc = ""
			this.imRoomUserList = []
            let _obj = this.imRoom
			if (!!_obj.roomId) {
				fetch.srmBaseImRoomUserRestful_listByPage({roomId: _obj.roomId, pageSize: 999}).then(res => {
					this.imRoomUserList = res.data
				})
				fetch.srmBaseImRoomRestful_findById({roomId: _obj.roomId}).then(res => {
					this.currentImRoom = res.data
					this.roomDesc = res.data.desc
				})
			}
            this.$nextTick(() => {
                this.showIMGroupModal = true;
            })
		},
		close() {
			this.$emit("on-close", true)

		},
        doSearchUser() {
          let _notInUserId = this.currentUserInfo.userId
            if (this.imRoomUserList.length > 0) {
              // 现次查询时不显示结果的用户ID列表
              this.imRoomUserList.forEach(item => {
                _notInUserId += (_notInUserId !== '' ? ',' : '') + item.userId
              })
            }
            this.userSelectConf.searchParams.notInUserId = _notInUserId
            this.$refs.UserSelectionModalRef.open({});
        },
        /**查询要通讯的用户*/
        userSelectOnChange(data) {
            if (!!!this.imRoomUserList) {
                this.imRoomUserList = []
            }
            // 检查用户是否已选择进列表
            const _chkUser = (userId) => {
                for (let i = 0; i < this.imRoomUserList.length; i++) {
                    if (userId === this.imRoomUserList[i].userId) {
                        return true
                    }
                }
                return false
            }
            if (!!data && data.length > 0) {
                let _roomDesc = ""
                for (let i = 0; i < data.length; i++) {
                    // 当前用户不需要添加到聊天室，会自动创建
                    if (data[i].userId === this.currentUserInfo.userId) {
                        continue
                    }
                    if (_chkUser(data[i].userId)) {
                        continue
                    }
                    if (!!!this.roomDesc) {
                        _roomDesc += (!!!_roomDesc ? '' : '，') + data[i].userFullName;
                    }
                    this.imRoomUserList.push({userId: data[i].userId, userName: data[i].userFullName, userType: data[i].userType})
                }
                if (!!!this.currentImRoom.roomId && !!_roomDesc) {
                    this.roomDesc = _roomDesc
                }
                this.userFullName = ""
                this.receiptMsg = []
            } else {
                this.userFullName = ""
            }
        },

		/**创建*/
        selectionOk() {
            if (!!!this.roomDesc) {
                Notify({ type: 'danger', message: '群组名称不能为空' });
                return
            }
            if (this.imRoomUserList.length <= 1) {
                Notify({ type: 'danger', message: '群组成员必需大于2人' });
                return
            }
            if (!!!this.currentImRoom.roomId) {
                this.nettyCreateRoom()
            } else {
                this.editRoomGroup()
            }
        },
        /**编辑聊天室信息*/
        editRoomGroup() {
            let _outCnt = 0;
            let _isCurrentUser = false
            let _addUserList = []
            for (let i =0; i < this.imRoomUserList.length; i++) {
                if (this.imRoomUserList[i].userType === "EXTERNAL") {
                    _outCnt++
                }
                if (this.currentUserInfo.userId === this.imRoomUserList[i].userId) {
                    _isCurrentUser = true
                }
                if (!!!this.imRoomUserList[i].roomId) {
                    this.imRoomUserList[i].roomId = this.currentImRoom.roomId
                    _addUserList.push(this.imRoomUserList[i])
                }
            }
            if (_outCnt > 1 && this.currentUserInfo.userType === "INSIDE") {
                Notify({ type: 'danger', message: '群组沟通中只能选择1家供应商' });
                return;
            }
            this.currentImRoom.userCount = this.currentImRoom.userCount + _addUserList.length
            this.currentImRoom.desc = this.roomDesc
            this.currentImRoom.imRoomUserVOList = _addUserList
            fetch.srmBaseImRoomRestful_saveOrUpdate(this.currentImRoom).then(res => {
                Notify({ type: 'success', message: '编辑群组信息成功' });
                this.showIMGroupModal = false;
                let _currentImRoom = this.currentImRoom
                _currentImRoom.roomId = null
                this.$emit("on-edit-room", res.data)
            })
            // console.log("editRoomGroup")
        },
        /**通过消息创建聊天室*/
        nettyCreateRoom() {
            let _outCnt = 0;
            let _isCurrentUser = false
            for (let i =0; i < this.imRoomUserList.length; i++) {
                if (this.imRoomUserList[i].userType === "EXTERNAL") {
                    _outCnt++
                }
                if (this.currentUserInfo.userId === this.imRoomUserList[i].userId) {
                    _isCurrentUser = true
                }
            }
            if (_outCnt > 1 && this.currentUserInfo.userType === "INSIDE") {
                Notify({ type: 'danger', message: '群组沟通中只能选择1家供应商' });
                return;
            }
            this.showIMGroupModal = false;

            this.currentImRoom = {
                desc: this.roomDesc,
                notice: null,
                userCount: this.imRoomUserList.length + 1,
                imRoomUserBeanList: this.imRoomUserList,
                sendUser: {userId: this.currentUserInfo.userId, userName: this.currentUserInfo.userFullName},
                isActive: true
            }
            // 当前发起人不在人员列表时，自动补偿到人员列表
            if (!_isCurrentUser) {
                this.currentImRoom.imRoomUserBeanList.push({
                    userId: this.currentUserInfo.userId,
                    userName: this.currentUserInfo.userFullName
                })
            }
            this.$emit("on-create-room", this.currentImRoom)
        },
        /**查询要通讯的用户*/
        userInfoFormChange(data) {
            // 检查用户是否已选择进列表
            const _chkUser = (userId) => {
                for (let i = 0; i < this.imRoomUserList.length; i++) {
                    if (userId === this.imRoomUserList[i].userId) {
                        return true
                    }
                }
                return false
            }
            if (!!data && data.length > 0) {
                let _roomDesc = ""
                for (let i = 0; i < data.length; i++) {
                    // 当前用户不需要添加到聊天室，会自动创建
                    if (data[i].userId === this.currentUserInfo.userId) {
                        continue
                    }
                    if (_chkUser(data[i].userId)) {
                        continue
                    }
                    if (!!!this.roomDesc) {
                        _roomDesc += (!!!_roomDesc ? '' : '，') + data[i].userFullName;
                    }
                    this.imRoomUserList.push({userId: data[i].userId, userName: data[i].userFullName, userType: data[i].userType})
                }
                if (!!!this.currentImRoom.roomId) {
                    this.roomDesc = _roomDesc
                }
                // this.setSingleIMRoom({userId: data.userId, userName: data.userFullName})
                this.userFullName = ""
                this.receiptMsg = []
            } else {
                this.userFullName = ""
            }
        },
        /**显示供应商全名称*/
        doShowFullUsername(item) {
            this.showUserFullName = true
            this.userFullName = item.userName
        },
        sheetClose() {
            this.showUserFullName = false
            this.userFullName = ""
        },
        /**把人员从聊天移出*/
        removeRoomUser(roomItem) {
            Dialog.confirm({
                title: '',
                message: '确认是否退出沟通群组？',
            }).then(() => {
                let _inx = -1;
                for (let i = 0; i < this.imRoomUserList.length; i++) {
                    if (roomItem.userId === this.imRoomUserList[i].userId) {
                        _inx = i
                        break
                    }
                }
                if (!!!roomItem.roomId) {
                    this.imRoomUserList.splice(_inx, 1)
                } else {
                    fetch.srmBaseImRoomUserRestful_delete(this.imRoomUserList[_inx]).then((res) => {
                        Notify({ type: 'success', message: '成功退出群组' });
                        this.showIMGroupModal = false;
                        let _currentImRoom = this.currentImRoom
                        _currentImRoom.roomId = null
                        this.$emit("on-edit-room", res.data)
                    })
                }
            })
        },
        /**设置聊天室成员*/
        setMultipleIMRoom({userId, userName }) {
            let _desc = null;
            let _userCnt = 2;
            _desc = "多人聊室"
            this.currentImRoom = {
                desc: _desc,
                notice: null,
                userCount: _userCnt,
                imRoomUserBeanList: this.imRoomUserList,
                sendUser: {userId: this.currentUserInfo.userId, userName: this.currentUserInfo.userFullName},
                isActive: true
            }
            if (userId !== this.currentUserInfo.userId) {
                let _receiptUser = {
                    userId: userId,
                    userName: userName
                }
                this.currentImRoom.imRoomUserBeanList.push(_receiptUser)
            }
            this.currentImRoom.imRoomUserBeanList.push({
                userId: this.currentUserInfo.userId,
                userName: this.currentUserInfo.userFullName
            })
            // this.doCreateImRoom(this.currentImRoom)
        }
	}
}



// WEBPACK FOOTER //
// ./src/page/srm/imManage/SrmImGroup.vue